(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ch-wholesale-configurator"] && !Shopify.designMode) return;
  try {
    function initChConfig(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const el=k=>root.querySelector('[data-c="'+k+'"]'),strings=Object.fromEntries([...el('strings').children].map(n=>[n.dataset.key,n.textContent])),s=k=>strings[k]||k;
 const catalog=JSON.parse(el('catalog').textContent),money=c=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:catalog.currency}).format(c/100);
 const selection=()=>{const p=catalog.products.find(p=>p.botanical===el('botanical').value&&p.base===el('base').value);return {p,v:p.variants.find(v=>v.size===el('size').value),q:Number(el('quantity').value)};};
 const valid=q=>Number.isInteger(q)&&q>=1&&q<=100;
 const row=(parent,label,value)=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;parent.append(dt,dd);};
 function render(){
  const {p,v,q}=selection(),sample=v?.unit==='oz';
  el('feedback').textContent='';el('ack').checked=false;el('ack').disabled=true;el('coa_panel').open=false;el('ack_status').textContent='';
  el('error').textContent=valid(q)?'':s('invalid');
  el('prices').replaceChildren();
  p.variants.filter(x=>sample?x.unit==='oz':x.unit==='US_gal').forEach(x=>{const tr=document.createElement('tr');if(x===v)tr.setAttribute('aria-current','true');[s(x.size),x.price_cents===null?s('pending'):money(x.price_cents),x.unit==='US_gal'&&x.price_cents!==null?money(x.price_cents/x.volume):'—'].forEach(value=>{const td=document.createElement('td');td.textContent=value;tr.append(td);});el('prices').append(tr);});
  el('total').textContent=!valid(q)?'—':!v?s('quote'):v.price_cents===null?s('pending'):money(v.price_cents*q);
  el('terms').textContent=s(!v?'partner':sample?'sample':'production');
  el('record').replaceChildren();
  el('coa_panel').hidden=true;el('ack_label').hidden=true;
  if(sample){
   const match=v.released&&v.coa;
   el('status').textContent=s(q>v.stock?'insufficient':match?'ready':'unavailable');
   row(el('record'),s('lot'),v.lot);row(el('record'),s('spec'),v.spec);row(el('record'),s('stock'),String(v.stock));row(el('record'),s('coa'),v.coa||s('unavailable'));
   if(match){el('coa_panel').hidden=false;el('ack_label').hidden=false;el('coa_record').textContent=[s(p.botanical),s(p.base),s(v.size),v.lot,v.spec,v.coa].join(' · ');el('ack_status').textContent=s('not_reviewed');}
  }else{el('status').textContent=s(v?'future':'custom_docs');if(v)row(el('record'),s('spec'),v.spec);}
 }
 ['botanical','base','size'].forEach(k=>el(k).addEventListener('change',render));el('quantity').addEventListener('input',render);
 el('coa_panel').addEventListener('toggle',()=>{if(el('coa_panel').open&&!el('coa_panel').hidden)el('ack').disabled=false;});
 el('ack').addEventListener('change',()=>{el('ack_status').textContent=s(el('ack').checked?'reviewed':'not_reviewed');});
 el('request').addEventListener('click',()=>{
  const {p,v,q}=selection();if(!valid(q)){el('error').textContent=s('invalid');el('quantity').focus();return;}
  const form=root.closest('.ch-w').querySelector('[data-ch-form]');if(!form)return;
  form.elements.path.value=!v?'partner':v.unit==='oz'?'evaluate':'order';
  const context=[s('demo'),s(p.botanical),s(p.base),s(el('size').value),s('quantity')+': '+q,s('total')+': '+el('total').textContent,el('status').textContent,v?.lot||'',v?.spec||'',v?.coa||'',el('ack_status').textContent].filter(Boolean).join(' | ');
  let field=form.querySelector('[data-ch-selection]');if(!field){const label=document.createElement('label');label.textContent=s('summary');field=document.createElement('textarea');field.name='selection';field.rows=4;field.readOnly=true;field.dataset.chSelection='true';label.append(field);form.prepend(label);}
  field.value=context;form.elements.botanical.value=s(p.botanical);form.elements.base.value=p.base;form.elements.quantity.value=s(el('size').value)+' × '+q;el('feedback').textContent=s('selected');root.closest('.ch-w').querySelector('[data-ch-summary]').hidden=true;form.scrollIntoView({block:'center',behavior:'auto'});form.elements.name.focus();
 });
 root.closest('.ch-w').querySelectorAll('[data-ch-path]').forEach(link=>{if(['evaluate','order'].includes(link.dataset.chPath)){link.href='#ch-configurator';link.addEventListener('click',()=>{el('size').value=link.dataset.chPath==='evaluate'?'sample1':'gallon1';render();});}});
 el('interactive').hidden=false;render();
}
document.querySelectorAll('[data-ch-config]').forEach(initChConfig);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ch-config]').forEach(initChConfig));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wek-launch-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-wek-launch-chat]');
  if (!button || button.disabled) return;
  const notice = button.closest('[data-wek-launch-banner]').querySelector('[data-wek-launch-status]');
  notice.hidden = true;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  let timeout;
  try {
    await Promise.race([
      customElements.whenDefined('shopify-chat'),
      new Promise((resolve, reject) => { timeout = setTimeout(() => reject(new Error('chat unavailable')), 8000); })
    ]);
    const chat = document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') throw new Error('chat unavailable');
    chat.show();
  } catch {
    notice.hidden = false;
  } finally {
    clearTimeout(timeout);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
  } catch(e) { console.error(e); }
})();

})();
